import { REQUEST_LINKEDIN_POST_SUCCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { posts: {}, errors: null };

export default function getLinkedInPosts(state=INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_LINKEDIN_POST_SUCCCESS:
      
      
      return { ...state, posts: action.payload.data, errors: null }
    default:
      return state;
  }
}